import secureLocalStorage from "react-secure-storage";
import { deviceDetect } from "react-device-detect";
import bcrypt from "bcryptjs";
import uuid from "react-uuid";

import * as api from "middlewares/apis";

import { fetchingDataFromApi } from "actions/loaders";
import { removeAllAccountsInNotificationDevice } from "actions/notifications";

import { GET_DEVICE_INFO, IS_USER_LOGGED_IN, LOGOUT_USER } from "helpers/constants";
import { findInObjectArrayByMatchingProperties } from "helpers/functions";
import dexieDB from "database/dexieDB";

export const getDeviceInfo = () => async (dispatch) => {
	try {
		const data = await dexieDB.deviceInfo
			.orderBy("id")
			.first()
			.then((deviceInfo) => {
				if (deviceInfo?.data) return deviceInfo.data;
				else return null;
			});

		if (data?.["device-id"]) {
			dispatch({ type: GET_DEVICE_INFO, payload: data });
		} else {
			const uniqueId = uuid();
			const deviceInfo = await deviceDetect();

			dexieDB.deviceInfo.add({ data: { ...deviceInfo, "device-id": uniqueId } }).then((id) => {
				if (id) dispatch({ type: GET_DEVICE_INFO, payload: { ...deviceInfo, "device-id": uniqueId } });
			});
		}
	} catch (error) {
		console.error(error);
	}
};

export const registerUser = async (formData, registrationType, navigatePage, notify) => {
	if (formData && registrationType) {
		try {
			const uniqueId = uuid();

			if (registrationType === "daffi") {
				// const { data } = await api.registerUser(formData);
				// if (data && data["data"]) {
				// 	return data["data"];
				// } else if (data && data["error"]) alert(JSON.stringify(data["message"]));
			} else if (registrationType === "local") {
				dexieDB.localUsers.add({ data: { ...formData, _id: uniqueId, "created-at": new Date() } }).then((id) => {
					if (id) {
						notify("success", "User is created");
						navigatePage("/");
					} else {
						notify("error", "User registration failed");
					}
				});
			}
		} catch (error) {
			console.error(error);
		}
	}
};

export const sendEmailVerificationOTP = async (formData) => {
	// if (formData) {
	// 	try {
	// 		const { data } = await api.sendEmailVerificationOTP(formData);
	// 		if (data && data["data"]) {
	// 			return data["data"];
	// 		} else if (data && data["error"]) alert(JSON.stringify(data["message"]));
	// 	} catch (error) {
	// 		console.error(error);
	// 	}
	// }
};

export const verifyEmailByOTP = async (formData) => {
	// if (formData) {
	// 	try {
	// 		const { data } = await api.verifyEmailByOTP(formData).catch((error) => alert(error["response"]["data"]["error"]));
	// 		if (data && data["data"] && data["data"]["verified-status"]) {
	// 			if (data["data"]["_id"] === formData["userID"]) {
	// 				return data["data"]["verified-status"];
	// 			}
	// 		} else if (data && data["error"]) {
	// 			alert(JSON.stringify(data["message"]));
	// 			return false;
	// 		}
	// 	} catch (error) {
	// 		console.error(error);
	// 	}
	// }
};

export const reinstallFromDaffiAccount = (formData, navigatePage) => async (dispatch) => {
	// let daffiUsers = secureLocalStorage.getItem("daffiUsers");
	// daffiUsers = daffiUsers ? [...daffiUsers, { ...formData }] : [{ ...formData }];
	// secureLocalStorage.setItem("daffiUsers", daffiUsers);
	// navigatePage("/");
};

export const getDaffiLoginToken = async (formData) => {
	// if (formData) {
	// 	try {
	// 		const { data } = await api.loginUser(formData);
	// 		if (data && data["data"] && data["data"]["access-token"]) {
	// 			return data["data"]["access-token"];
	// 		}
	// 		// if (data && data["message"]) {
	// 		// 	alert(data["message"]);
	// 		// }
	// 	} catch (error) {
	// 		console.error(error);
	// 	}
	// }
};

export const loginUser = (formData, loginType, navigatePage, notify) => async (dispatch) => {
	if (formData && loginType) {
		try {
			dispatch(fetchingDataFromApi(true));

			if (loginType === "daffi") {
				// let daffiUsers = secureLocalStorage.getItem("daffiUsers");
				// let daffiUser = findInObjectArrayByMatchingProperties(daffiUsers, {
				// 	username: formData["username"],
				// });
				// daffiUser = daffiUser["0"];
				// await bcrypt.compare(formData["password"], daffiUser["password"]).then((data) => {
				// 	if (data) {
				// 		secureLocalStorage.setItem("currentUser", daffiUser);
				// 		secureLocalStorage.setItem("currentUserStatus", true);
				// 		navigatePage("/");
				// 		dispatch({
				// 			type: IS_USER_LOGGED_IN,
				// 		});
				// 	} else {
				// 		alert("Invalid password");
				// 	}
				// });
			} else if (loginType === "local") {
				const localUser = await dexieDB.localUsers
					.filter((localUser) => localUser.data.username === formData["username"])
					.first()
					.then((localUser) => {
						if (localUser) {
							return localUser.data;
						}
					});

				await bcrypt.compare(formData["password"], localUser["password"]).then((data) => {
					if (data) {
						secureLocalStorage.setItem("currentUser", localUser);
						secureLocalStorage.setItem("currentUserStatus", true);

						navigatePage("/");

						dispatch({
							type: IS_USER_LOGGED_IN,
						});
					} else {
						notify("error", "Invalid password");
					}
				});
			}

			dispatch(fetchingDataFromApi(false));
		} catch (error) {
			console.error(error);
		}
	}
};

export const verifyUserPin = async (pin) => {
	const currentUser = secureLocalStorage.getItem("currentUser");
	let verified = null;

	if (pin) {
		try {
			if (currentUser?.loginType === "daffi") {
				// let daffiUsers = secureLocalStorage.getItem("daffiUsers");
				// let daffiUser = findInObjectArrayByMatchingProperties(daffiUsers, {
				// 	_id: currentUser?._id,
				// });
				// daffiUser = daffiUser["0"];
				// await bcrypt.compare(pin, daffiUser["password"]).then((data) => {
				// 	if (data) verified = true;
				// 	else verified = false;
				// });
				// return verified;
			} else if (currentUser?.loginType === "local") {
				const userData = await dexieDB.localUsers
					.filter((item) => item?.data?._id === currentUser?._id)
					.first()
					.then((data) => {
						if (data?.data) {
							return data?.data;
						} else return null;
					});

				if (userData?.password) {
					await bcrypt.compare(pin, userData.password).then((data) => {
						if (data) verified = true;
						else verified = false;
					});
				}

				return verified;
			}
		} catch (error) {
			console.error(error);
		}
	}
};

export const verifyUserLogin = () => async (dispatch) => {
	// const token = secureLocalStorage.getItem("token");
	// if (token) {
	// 	try {
	// 		const { data } = await api.verifyUserLogin(token);
	// 		if (data?.username) {
	// 			dispatch({
	// 				type: IS_USER_LOGGED_IN,
	// 				payload: true,
	// 			});
	// 		} else if (data?.error) {
	// 			dispatch({
	// 				type: IS_USER_LOGGED_IN,
	// 				payload: false,
	// 			});
	// 			dispatch({ type: LOGOUT_USER });
	// 		}
	// 	} catch (error) {
	// 		console.error(error);
	// 	}
	// }
};

export const checkUsernameAvailabilityInLocal = async (username, LoginType) => {
	if ((username, LoginType)) {
		if (LoginType === "daffi") {
			// let daffiUsers = secureLocalStorage.getItem("daffiUsers");
			// const daffiUser = findInObjectArrayByMatchingProperties(daffiUsers, {
			// 	username: username,
			// });
			// if (daffiUser && daffiUser.length) return false;
			// else return true;
		} else if (LoginType === "local") {
			const localUser = await dexieDB.localUsers
				.filter((localUsers) => JSON.parse(localUsers.data).username === username)
				.first()
				.then((user) => {
					if (user) {
						return JSON.parse(user.data);
					}
				});

			if (localUser?.username) return false;
			else return true;
		}
	}
};

export const checkUsernameAvailabilityInServer = async (username) => {
	// if (username) {
	// 	try {
	// 		const { data } = await api.checkUsernameAvailability(username);
	// 		return data["data"];
	// 	} catch (error) {
	// 		console.error(error);
	// 	}
	// }
};

export const checkEmailAvailabilityInServer = async (email) => {
	// if (email) {
	// 	try {
	// 		const { data } = await api.checkEmailAvailability(email);
	// 		return data["data"];
	// 	} catch (error) {
	// 		console.error(error);
	// 	}
	// }
};

export const logoutUser = (navigatePage, notify) => async (dispatch) => {
	removeAllAccountsInNotificationDevice(notify);

	dispatch({
		type: LOGOUT_USER,
	});

	navigatePage("/");
};
